import { useAppContext } from './context/appContext';
import { useNavigate } from 'react-router-dom';
import Loading from './components/loading';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBInput,
  MDBRow,
  MDBTypography,
} from "mdb-react-ui-kit";
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import CreditCardIcon from '@mui/icons-material/CreditCard';


const Checkout = () => {
  const navigate = useNavigate();

  let {
    isLoading,
    showAlert,
    shoppingCart,
    setProducts,
    ccPayment
  } = useAppContext();

  const [formData, setFormData] = useState({
    cardholderName: '',
    cardNumber: '',
    expiration: '',
    cvv: ''
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const handlePayment = async (event) => {
    event.preventDefault();
    const { cardholderName, cardNumber, expiration, cvv } = formData;
    const resp = await ccPayment(cardholderName, cardNumber, expiration, cvv);
    setProducts([]);
    if(resp.status === 'success') {
      navigate('/e-commerce/payment-success');
    } else {
      navigate('/e-commerce/payment-fail');
    }
  };

  // Group products by their ID and calculate quantities
  const { groupedProducts, totalPrice } = shoppingCart.reduce((acc, product) => {
    if (acc.groupedProducts[product._id]) {
      // If product ID already exists, increment quantity
      acc.groupedProducts[product._id].quantity += 1;
    } else {
      // Otherwise, add the product with quantity 1
      acc.groupedProducts[product._id] = {
        ...product,
        quantity: 1,
      };
    }
    acc.totalPrice += product.price;
    return acc;
  }, {groupedProducts: [], totalPrice: 0});

  const isCartEmpty = shoppingCart.length === 0;

  const handleDelete = (productId) => {
    let updateShoppingCart = shoppingCart.filter((item) => item._id !== productId);
    setProducts(updateShoppingCart);
  };

  if (isLoading) {
    return <Loading center />;
  }

  return (
    <>
    <section className="h-100 h-custom" style={{ backgroundColor: "#eee" }}>
      <MDBContainer className="py-5 h-100">
        <MDBRow className="justify-content-center align-items-center h-100">
          <MDBCol>
            <MDBCard>
              <MDBCardBody className="p-4">
                <MDBRow>
                  <MDBCol lg="7">
                    <MDBTypography tag="h5">
                      <a href='/product-list' className="text-body">
                        <MDBIcon fas icon="long-arrow-alt-left me-2" /> Continue
                        shopping
                      </a>
                    </MDBTypography>
                    <hr />
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <div>
                        <p className="mb-1">Shopping cart</p>
                        <p className="mb-0">You have {shoppingCart.length} items in your cart</p>
                      </div>
                    </div>

                    {Object.values(groupedProducts).map((product, index) => (
                      <MDBCard key={index} className="mb-3">
                        <MDBCardBody>
                        <div className="d-flex justify-content-between">
                          <div className="d-flex flex-row align-items-center">
                            <div>
                              <MDBCardImage
                                src={require(`../../assets/images/products/${product.imageUrl}`)}
                                fluid
                                className="rounded-3"
                                style={{ width: "65px" }}
                                alt="Shopping item"
                              />
                            </div>
                            <div className="ms-3">
                              <MDBTypography tag="h5">
                                {product.name}
                              </MDBTypography>
                            </div>
                          </div>
                          <div className="d-flex flex-row align-items-center">
                            <div style={{ width: "50px" }}>
                              <MDBTypography
                                tag="h5"
                                className="fw-normal mb-0"
                              >
                                {product.quantity}
                              </MDBTypography>
                            </div>
                            <div style={{ width: "80px" }}>
                              <MDBTypography tag="h5" className="mb-0">
                                {product.price}
                              </MDBTypography>
                            </div>
                            <a onClick={() => handleDelete(product._id)} href="#!" style={{ color: "#cecece" }}>
                              <DeleteIcon />
                            </a>
                          </div>
                        </div>
                        </MDBCardBody>
                      </MDBCard>
                    ))}
                  </MDBCol>

                  <MDBCol lg="5">
                    <MDBCard className="bg-primary text-white rounded-3">
                      <MDBCardBody>
                        <div className="d-flex justify-content-between align-items-center mb-4">
                          <MDBTypography tag="h5" className="mb-0">
                            Card details
                          </MDBTypography>
                        </div>
                        <span>Demo valid card number</span>
                        <ul>
                          <li><CreditCardIcon></CreditCardIcon> 4242424242424242</li>
                          <li><CreditCardIcon></CreditCardIcon> 4111111111111111</li>
                          <li><CreditCardIcon></CreditCardIcon> 5555555555554444</li>
                        </ul>

                        <form className="mt-4" onSubmit={handlePayment}>
                          <MDBInput
                            className="mb-4"
                            label="Cardholder's Name"
                            type="text"
                            size="lg"
                            placeholder="Cardholder's Name"
                            contrast
                            name="cardholderName"
                            value={formData.cardholderName}
                            onChange={handleInputChange}
                          />

                          <MDBInput
                            className="mb-4"
                            label="Card Number"
                            type="text"
                            size="lg"
                            minLength="16"
                            maxLength="16"
                            placeholder="1234567890123457"
                            contrast
                            name="cardNumber"
                            value={formData.cardNumber}
                            onChange={handleInputChange}
                          />

                          <MDBRow className="mb-4">
                            <MDBCol md="6">
                              <MDBInput
                                className="mb-4"
                                label="Expiration"
                                type="text"
                                size="lg"
                                minLength="7"
                                maxLength="7"
                                placeholder="MM/YYYY"
                                contrast
                                name="expiration"
                                value={formData.expiration}
                                onChange={handleInputChange}
                              />
                            </MDBCol>
                            <MDBCol md="6">
                              <MDBInput
                                className="mb-4"
                                label="Cvv"
                                type="text"
                                size="lg"
                                minLength="3"
                                maxLength="3"
                                placeholder="&#9679;&#9679;&#9679;"
                                contrast
                                name="cvv"
                                value={formData.cvv}
                                onChange={handleInputChange}
                              />
                            </MDBCol>
                          </MDBRow>
                        
                          <hr />

                          <div className="d-flex justify-content-between">
                            <p className="mb-2">Total</p>
                            <p className="mb-2">{totalPrice}</p>
                          </div>

                          <MDBBtn disabled={isCartEmpty} color="info" block size="lg" style={{height: 60}}>
                              <strong>
                                Payment {" "}
                                <i className="fas fa-long-arrow-alt-right ms-2"></i>
                              </strong>
                          </MDBBtn> 
                        </form>                        
                      </MDBCardBody>
                    </MDBCard>
                  </MDBCol>
                </MDBRow>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </section>
    </>
  );
};

export default Checkout;